import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";

import { TVehicle } from "types";
import { Tupel } from "components";

interface IEmissions {
  vehicle: TVehicle;
}

export const Elektro: React.FC<IEmissions> = ({ vehicle }): JSX.Element => (
  <>
    <Typography variant="h6" component="h3">
      <FormattedMessage
        id="term.stromverbrauch"
        defaultMessage="Stromverbrauch"
      />
    </Typography>
    <Tupel
      labelId="term.combined"
      label="kombiniert"
      float={vehicle.wltp_stromverbrauch_kombiniert}
      unit="kWh/100km"
      boxProps={{ fontWeight: "bold" }}
    />
    <Tupel
      labelId="term.innenstadt"
      label="Innenstadt"
      float={vehicle.wltp_stromverbrauch_langsam}
      unit="kWh/100km"
    />
    <Tupel
      labelId="term.stadtrand"
      label="Stadtrand"
      float={vehicle.wltp_stromverbrauch_mittel}
      unit="kWh/100km"
    />
    <Tupel
      labelId="term.landstrasse"
      label="Landstraße"
      float={vehicle.wltp_stromverbrauch_schnell}
      unit="kWh/100km"
    />
    <Tupel
      labelId="term.autobahn"
      label="Autobahn"
      float={vehicle.wltp_stromverbrauch_sehr_schnell}
      unit="kWh/100km"
    />
  </>
);

export default Elektro;
